var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"post mb-3"},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"card-heading,  list-item-two-line"}},'v-skeleton-loader',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }